import React from "react";

export const Logo = ({ source }) => (<img style={{ maxHeight: '97px', maxWidth: '97px' }} src={source ? `${source}` : '/static/media/icon-profle.png'}/>)
